import { render, staticRenderFns } from "./Mri2026View.vue?vue&type=template&id=ec128b58&scoped=true&"
import script from "./Mri2026View.vue?vue&type=script&lang=js&"
export * from "./Mri2026View.vue?vue&type=script&lang=js&"
import style0 from "./Mri2026View.vue?vue&type=style&index=0&id=ec128b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec128b58",
  null
  
)

export default component.exports